import { render } from "./ButtonTabs.vue?vue&type=template&id=c28fd01a"
import script from "./ButtonTabs.vue?vue&type=script&lang=js"
export * from "./ButtonTabs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__